"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogTitle: function() {
        return _index.DialogTitle;
    },
    dialogTitleClassNames: function() {
        return _index.dialogTitleClassNames;
    },
    renderDialogTitle_unstable: function() {
        return _index.renderDialogTitle_unstable;
    },
    useDialogTitleInternalStyles: function() {
        return _index.useDialogTitleInternalStyles;
    },
    useDialogTitleStyles_unstable: function() {
        return _index.useDialogTitleStyles_unstable;
    },
    useDialogTitle_unstable: function() {
        return _index.useDialogTitle_unstable;
    }
});
const _index = require("./components/DialogTitle/index");
